export var createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer = function createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer(overwriteAccessors) {
  return function (nativeAudioBufferSourceNode, nativeContext) {
    var nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);
    if (nativeAudioBufferSourceNode.buffer === null) {
      nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
    }
    overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', function (get) {
      return function () {
        var value = get.call(nativeAudioBufferSourceNode);
        return value === nullifiedBuffer ? null : value;
      };
    }, function (set) {
      return function (value) {
        return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
      };
    });
  };
};